export const summerbarbeque = {
  name: 'Summer Barbeque',
  color: [0.4588235294117647, 0.16470588235294117, 0.027450980392156862, 1],
  bg: [0.3607843137254902, 0.5607843137254902, 0.13333333333333333, 1],
  grid1: [0.984313725490196, 0.796078431372549, 0.4823529411764706, 1],
  grid2: [0.8117647058823529, 0.21568627450980393, 0.12941176470588237, 1],
}
